// test1224
(1224 && 0);
